<template>
  <strong class="flex gap-200">
    <div class="flex items-center gap-100">
      <LcIcon
        class="extra-hit"
        :class="{ 'extra-hit--filled': isExtraHitEnabled }"
        :name="extraHitIcon"
        size="medium"
      />
      <span class="extra-hit__text">
        {{ $t(`lottery.${lotteryId}.extrahit`) }}
      </span>
      <LcInfoButton
        :key="`infobutton_${locale}`"
        :headline="$t(`lottery.${lotteryId}.extrahit.info.headline`)"
        :open-button-aria-label="$t(`lottery.${lotteryId}.extrahit.info.label`)"
        :text="$t(`lottery.${lotteryId}.extrahit.info.message`)"
      />
    </div>

    <LcSwitch
      v-model:value="model"
      :aria-label-text="$t(`lottery.${lotteryId}.extrahit`)"
      icon="checkmark"
      name="switch"
      variant="success"
    />
  </strong>
</template>

<script setup lang="ts">
import type { LcIconProps } from '@lottocom/frontend-components'

import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type NumberLotteryBaseExtraHitEmits = {
  (event: 'update:value', value: boolean): void
}

type NumberLotteryBaseExtraHitProps = {
  isExtraHitEnabled: boolean
  lotteryColor: string
  lotteryId: LotteryId
}

const emit = defineEmits<NumberLotteryBaseExtraHitEmits>()
const { isExtraHitEnabled, lotteryColor, lotteryId } = defineProps<NumberLotteryBaseExtraHitProps>()

const { locale, t } = useI18n()

const extraHitIcon = computed(
  () => `hit-${t(`lottery.${lotteryId}.extrahit`).toLowerCase()}` as LcIconProps['name'],
)
const model = computed({
  get: () => isExtraHitEnabled,
  set: (value) => {
    emit('update:value', value)
  },
})
</script>

<style lang="scss" scoped>
.extra-hit {
  border: 1px solid token('color/icon/primary/primary');
  border-radius: token('size/radius/full');

  &--filled {
    border-color: v-bind(lotteryColor);
    background-color: v-bind(lotteryColor);
    color: token('color/icon/primary/primary-inverted');
  }

  &__text {
    min-width: 3.57rem;
  }
}
</style>
